import { TextField, styled } from '@mui/material';

export const StyledTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    '&.Mui-focused': {
      background: '#F6F6F6',
      borderRadius: '10px',
      '&.Mui-error': {
        border: '1px solid #FF154D',
      },
    },
    '& .MuiAutocomplete-inputFocused': {
      padding: '0',
      minHeight: '24px',
    },
    '& .MuiAutocomplete-endAdornment': {
      right: 6,
    },
    '& .MuiSelect-icon': {
      right: 6,
    },
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
  },
});
